import * as React from 'react';
import Base from './base';
// import * as moment from 'moment';
const moment = require('moment');
const momenTimezone = require('moment-timezone');
import DatePicker from '../../DatePicker';
import { DATE_ARRAY_FIELDS, DATE_FORMAT,TIME_FORMAT,ACTIVITY_DATE_ARRAY_FIELDS } from "../../../containers/WorkkardDetail/constants";
import { insertStringScript, removeErrorOnFocus } from "../../../common/util";
import { DEFAULT_TIME_FORMAT,DEFAULT_DATE_FORMAT } from '../../../common/constants';
import InlineEditableField from '../../InlineEditableField';
import FormDatePicker from '../../FormComponents/formDatePicker';
import { Field } from 'redux-form';

class Date extends Base {
    constructor(props) {
        super(props);
        this.state = {
            selectedDate: ""
        }
    }

    getDateWithFormat(date,format){
        return (date && date != "" && Object.prototype.toString.apply(date) === "[object String]") ? moment(date, [format]) : date;
    }


    getDateValue(data) {
        let dateValue = data.Value !== "" ? moment(data.Value).isValid() ? moment.utc(data.Value).format(DATE_FORMAT) : "-" : "-";
        this.setState({ selectedDate: dateValue });
    }

   
    renderOnCard() {
        let {renderType, data, showLabel=false,timezone} = this.props;
        if(Array.isArray(data))
            data = data[0];
        
        let dateValue = data.Value !== "" ? (timezone? momenTimezone(data.Value).tz(timezone).format(DATE_FORMAT) : moment.utc(data.Value).format(DATE_FORMAT)) : "-"
            return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label> : <span className={timezone ? "red":""}>{dateValue}</span></li>)
                :
                (<li data-test={dateValue}>{dateValue}</li>)
    }
    renderOnGrid() {
        return (
            <div></div>
        )
    }
    renderOnDetail() {
        let { renderType, data, showLabel = false } = this.props;
        if (Array.isArray(data))
            data = data[0];

        let dateValue = data.Value !== "" ? moment(data.Value).isValid() ? moment.utc(data.Value).format(DATE_FORMAT) : "-" : "-"
        if (renderType.toLowerCase() === 'activity') {
            if(showLabel){
             return (<li data-test={data.Label}>
                    <label>{data.Label}</label>
                    <InlineEditableField
                    type="date"
                    data={data}
                    fieldValue={dateValue}
                    canEdit={this.props.canEditActivity}
                    isCompositeField={false}
                    removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                    updateField={(data) => this.props.updateActivityField(data)} />
            </li>)
            }
               else{
                   return (<li data-test={dateValue}>{dateValue}</li>);
               }
        } else if (renderType.toLowerCase() === 'workkard') {
            if (showLabel) {
                return (<li data-test={data.Label}>
                    <label data-field-label={this.props.isShowDetailOnPopUp ? data.FieldKey+"label_block" : data.FieldKey}>{data.Label} </label>
                    {(this.props.dragndrop || !this.props.isShowDetailOnPopUp)
                        ? (<span>{dateValue}</span>)
                        : <InlineEditableField
                            type="date"
                            data={data}
                            fieldValue={dateValue}
                            canEdit={this.props.canEditWorkkard}
                            isCompositeField={false}
                            removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                            updateField={(data) => this.props.updateWorkkardFieldInfo(data)} />
                    }
                </li>);
            } else {
                return (dateValue);
            }
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{dateValue}</React.Fragment>)
                :
                (dateValue)
        }
    }

    renderOnCreate() {
        let { renderType, data, showLabel = false, pastDate, futureDate } = this.props;  
        if(Array.isArray(data))
            data = data[0];  
        const fieldSetting = data.settings ? JSON.parse(data.settings) : {};
        const format = fieldSetting.input_time_component ? TIME_FORMAT:DATE_FORMAT;
        if (renderType.toLowerCase() === 'note') {
            var dateFieldArray = DATE_ARRAY_FIELDS;
            dateFieldArray.forEach((element) => {
                if (data.Label == element) {
                    futureDate = moment()
                }
            });

            return (showLabel) ?
                (<div data-field-key={data.FieldKey}>
                    <label>{data.Label}{data.IsMandatory ? <span className="red">*</span> : ""} </label>
                    <div className="FieldBlock date">
                        <DatePicker
                          id={data.FieldKey}
                          minDate={moment(pastDate)}
                          maxDate={futureDate}
                          calendarClassName="animated faster fadeInUpx2"
                          onFocus={(e)=>removeErrorOnFocus(e)}
                          selectedDate={this.getDateWithFormat(data.Value,format) || null}
                          timeIntervals={15}
                          showSysTime={Boolean(fieldSetting.time_from && fieldSetting.time_from.includes("user"))}
                          myContainer={true}
                          showComment={false}
                          showTimePicker={fieldSetting.input_time_component}
                          dateFormat={fieldSetting.output_time_component?DEFAULT_TIME_FORMAT:DEFAULT_DATE_FORMAT }
                          onChange={(e) => this.props.onFieldValueChange({ name: data.FieldKey, value: moment(e).isValid() ? moment(e).format(format):"" })}
                          showCalenderIcon ={true}
                          shouldCloseOnSelect={fieldSetting.output_time_component?false:true}
                        />
                        <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                    </div>
                </div>)
                :
                (<div>{data.Value}</div>)
        }
        else if (renderType.toLowerCase() === 'activity') {
            var dateFieldArray = ACTIVITY_DATE_ARRAY_FIELDS;
            dateFieldArray.forEach((element) => {
                if (data.Label == element) {
                    futureDate = moment();
                }
            });
           return(
            <div className="formGroup">
                {data.Label.trim() != "" && <label className="wth-3">{data.Label}{data.IsRequired && <sup>*</sup>}</label>}
                <div className={`${renderType.toLowerCase()=="activity"? "":"dueDate"} datePicker`}>
                    <Field
                        component={FormDatePicker}
                        name={data.Name}
                        maxDate={futureDate}
                        id={data.FieldKey}
                        showTime={fieldSetting.input_time_component || false}
                        popperClassName=""
                        wrapperClass={`formGroup ${renderType.toLowerCase()=="activity"? "":"wth-9"} mrNone`}
                        isDisabled={this.props.data.IsNonEditable}
                        placeholderText={this.props.Value=="" ? this.props.data.Label :""}
                        openTodate={false}
                        dateFormat={format}
                    />
                </div>   
            </div>
           )
        }
    }

    runPreScript(id,preScript) {
        insertStringScript(id,preScript)
    }

    runPostScript(id,postScript) {
        insertStringScript(id,postScript)
    }

    componentDidMount() {
       const data= Array.isArray(this.props.data) ? this.props.data[0] : this.props.data;
        if (data && data.PreInitScript) {
            this.runPreScript(`preInitScript-${data.FieldKey}`,data.PreInitScript);
        }
        if (data && data.PreSaveScript) {
            this.runPostScript(`preSaveScript-${data.FieldKey}`,data.PreSaveScript);
        }
    }
}

export default Date;